// ============================================================================
// OBT F3-D — Kurumsal Hafıza (park varlık geçmişi) API katmanı (paket-yerel)
// ============================================================================
// Tüm yollar backend `modules/obt/api.py` ile doğrulanmıştır (dual-mount
// `/obt` → /api + /api/v1). Aktör kimliği HİÇBİR çağrıda body/query ile
// GÖNDERİLMEZ; kapsam backend'de JWT + ChainService ile çözülür (vekâlet
// kapsamı GENİŞLETMEZ; Park Görevlisi reddedilir).
// ============================================================================

import apiClient from '@/api/client';

const OBT = '/obt';
const enc = encodeURIComponent;

export async function fetchScopeParks({ signal } = {}) {
  const res = await apiClient.get(`${OBT}/asset-scope-parks`, { signal });
  return res.data; // { items: [{park_id, park_name, region_name, asset_count}] }
}

export async function fetchParkAssetHistory(parkId, { signal } = {}) {
  const res = await apiClient.get(`${OBT}/parks/${enc(parkId)}/asset-history`, { signal });
  return res.data; // ParkAssetHistoryOut { park_id, park_name, assets: [{asset, records}] }
}

export async function fetchAssetHistory(assetId, { signal } = {}) {
  const res = await apiClient.get(`${OBT}/assets/${enc(assetId)}/history`, { signal });
  return res.data;
}

export async function createAsset(parkId, { assetType, name, description } = {}, { signal } = {}) {
  const res = await apiClient.post(
    `${OBT}/parks/${enc(parkId)}/assets`,
    { asset_type: assetType, name: name ?? null, description: description ?? null },
    { signal }
  );
  return res.data; // AssetOut
}

/**
 * Varlığa append-only kayıt ekle (multipart; opsiyonel fotoğraflar).
 * @param {File[]} files
 */
export async function addAssetRecord(assetId, fields = {}, files = [], { signal } = {}) {
  const form = new FormData();
  form.append('event_type', fields.eventType || 'maintenance');
  const map = {
    event_date: fields.eventDate,
    description: fields.description,
    company_name: fields.companyName,
    tender_number: fields.tenderNumber,
    warranty_start_date: fields.warrantyStart,
    warranty_end_date: fields.warrantyEnd,
    notes: fields.notes,
  };
  for (const [k, v] of Object.entries(map)) {
    if (v !== undefined && v !== null && v !== '') form.append(k, v);
  }
  for (const f of files || []) form.append('files', f, f.name);
  const res = await apiClient.post(`${OBT}/assets/${enc(assetId)}/records`, form, {
    signal,
    headers: { 'Content-Type': undefined },
  });
  return res.data; // AssetRecordOut
}

export async function uploadAssetPhoto(recordId, file, { signal } = {}) {
  const form = new FormData();
  form.append('file', file, file.name);
  const res = await apiClient.post(
    `${OBT}/asset-records/${enc(recordId)}/media/photos`,
    form,
    { signal, headers: { 'Content-Type': undefined } }
  );
  return res.data;
}

/** Fotoğraf blob'unu güvenli oku (ACL backend'de). objectUrl döndürür. */
export async function readAssetPhoto(recordId, photoId, { signal } = {}) {
  const res = await apiClient.get(
    `${OBT}/asset-records/${enc(recordId)}/media/${enc(photoId)}`,
    { signal, responseType: 'blob' }
  );
  const blob = res.data;
  return {
    objectUrl: URL.createObjectURL(blob),
    mimeType: blob?.type || res.headers?.['content-type'] || 'image/*',
  };
}
